export default __webpack_public_path__ + "static/media/Messages.9edb26b2.svg";